import React, { useState, useEffect} from 'react'
import FirstFiftyHeader from '../components/firstFifty/FirstFiftyHeader'
import Banner from '../components/firstFifty/Banner'
import WhatAreSnapVideo from '../components/firstFifty/WhatAreSnapVideo'
import HelpShape from '../components/firstFifty/HelpShape'
import SpecialLunchOffer from '../components/firstFifty/SpecialLunchOffer'
import GetRayBanPair from '../components/firstFifty/GetRayBanPair'
import ReserveSpot from '../components/firstFifty/ReserveSpot'
import Footer from '../components/firstFifty/Footer'
import '../components/firstFifty/firstFifty.css'
import '../components/firstFifty/firstFiftyResponsive.css'
import { KeyboardArrowUp } from '@mui/icons-material';
import ExampleVideos from '../components/firstFifty/ExampleVideos'
import StartTestimonialSection from '../components/HomePage/StartTestimonialSection'

function FirstFifty() {
  const [showScroll, setShowScroll] = useState(false);
  
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const rootElement = document.getElementById("root");

      if (rootElement) {
        if (scrollY >= 70) {
          rootElement.classList.add("sticky");
        } else {
          rootElement.classList.remove("sticky");
        }
      }

      if (scrollY > 100) {
        setShowScroll(true);
      } else {
        setShowScroll(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    const duration = 2000; // in milliseconds (1000ms = 1s)
    const start = window.scrollY;
    const startTime = performance.now();

    const animateScroll = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1); // 0 to 1

      // easeInOutQuad easing function
      const ease = progress < 0.5
        ? 2 * progress * progress
        : -1 + (4 - 2 * progress) * progress;

      window.scrollTo(0, start * (1 - ease));

      if (elapsed < duration) {
        requestAnimationFrame(animateScroll);
      }
    };

    requestAnimationFrame(animateScroll);
};

  return (
    <div className='firstFifty'>
        <FirstFiftyHeader />
        <main>
            <Banner />
            <WhatAreSnapVideo />
            <ExampleVideos />
            <HelpShape />
            <SpecialLunchOffer />
            <GetRayBanPair  />
            <StartTestimonialSection heading={true}/>
            <ReserveSpot />
        </main>
        <Footer />
        <a onClick={scrollToTop} id="myBtn" style={{ display: showScroll ? "flex" : "none", justifyContent: 'center', alignItems: 'center' }}><KeyboardArrowUp fontSize="large" /></a>
    </div>
  )
}

export default FirstFifty